import * as Sentry from '@sentry/react';

import {ITokenData, IVerifyResponse} from '@/app/auth';
import {RoleType, useAppDispatch} from '@/app/store';
import {setTokenData} from '@/app/store/tokenSlice';
import {getTokenDecodedUser} from '@/hooks';
import {obscureName} from '@/utils/obscureName';

export const useAuthenticationToken = () => {
  // Dependencies
  const dispatch = useAppDispatch();

  // Logic
  const manageDataToken = (response: IVerifyResponse): RoleType => {
    const authentication = getUserAuthenticated(response);
    dispatch(setTokenData(authentication));
    const userData: Sentry.User = {
      id: authentication.id,
      name: obscureName(authentication.name),
      role: authentication.role,
    };
    Sentry.setUser(userData);

    return authentication.role;
  };

  const getUserAuthenticated = (response: IVerifyResponse): ITokenData => {
    const tokenDecoded = getTokenDecodedUser(response?.accessToken);
    return {
      id: tokenDecoded?.user_uuid,
      name: tokenDecoded?.name,
      email: tokenDecoded?.email,
      phone: tokenDecoded?.phone_number,
      role: tokenDecoded?.role,
      accessToken: response?.accessToken || response?.access,
      refreshToken: response?.refreshToken || response?.refresh,
    };
  };

  return {
    manageDataToken,
  };
};
